import { createMachine, interpret, assign } from "xstate";

const sortGoals = (dir = "DESC") => {
	const isDesc = dir.toLocaleUpperCase() === "DESC";
	if (isDesc) {
		return (a, b) => b.goal - a.goal;
	} else {
		return (a, b) => a.goal - b.goal;
	}
};

const isUnlocked = (goal, total, log) => {
	if (log) console.log(`total: ${total}, goal: ${goal}, unlocked: ${total >= goal}`);
	return total >= goal
};

const calculateGoals = ({
	campaign_id,
	goals,
	shopify_cart_items,
	original,
	subtotal,
	bundlesDiscounts,
	byQuantity,
	contextCache,
	setShowConfetti
}) => {
	const descGoals = [...goals].sort(sortGoals("DESC"));
	const ascGoals = [...goals].sort(sortGoals("ASC"));
	const goalValue = (goal) => byQuantity ? goal : parseInt(goal * 100 * parseFloat(window.Shopify.currency.rate));
	const getTotal = (reward_type) => {
		const total = byQuantity
			? totalItems
			: reward_type === "free_shipping"
				? subtotal
				: original - bundlesDiscounts;
		return total
	}
	const totalItems = shopify_cart_items.filter(({ price }) => Number(price) > 0).reduce((acc, cur) => acc + cur.quantity, 0);
	return ascGoals.map((goalObject, index) => {
		const { goal, reward_type, confetti, confetti_length } = goalObject;
		const total = getTotal(reward_type)
		const unlocked = isUnlocked(goalValue(goal), total);
		const wasLocked = contextCache ? contextCache?.goals[index]?.unlocked === false : null;
		const value = Math.min(100, Number(((total / goalValue(goal)) * 100).toFixed(2)));

		const isDescending = contextCache ? contextCache?.goals[index]?.value > value : false;
		const previousGoal = index > 0 ? ascGoals[index - 1] : {};
		if (confetti && !isDescending && unlocked && wasLocked) {
			setShowConfetti(confetti_length);
		}
		return {
			campaign_id,
			key: "atu_goal_" + index,
			textKey: "atu_goal_text_" + index,
			labelKey: "atu_goal_label_" + index,
			goalObject,
			value,
			previousIsUnlocked: previousGoal?.goal || previousGoal?.goal === 0 ? isUnlocked(goalValue(previousGoal.goal), getTotal(previousGoal.reward_type)) : undefined,
			isFirst: index === 0,
			isLast: index === ascGoals.length - 1,
			unlocked
			// animating:false
		};
	});
};

const HeaderMachine = ({
	campaign_id,
	goals,
	shopify_cart_items,
	byQuantity,
	original,
	subtotal,
	bundlesDiscounts,
	contextCache,
	setShowConfetti
}) => {
	// const highestGoal = descGoals[0];
	return createMachine({
		id: "header-machine",
		// initial: "idle",
		context: {
			goals: calculateGoals({
				campaign_id,
				goals,
				shopify_cart_items,
				original,
				subtotal,
				byQuantity,
				bundlesDiscounts,
				contextCache,
				setShowConfetti
			})
		}
		// states: {
		// 	idle: {
		// 		on: {
		// 			START_ANIMATION: {
		// 				actions: (context, event) => {
		// 					const goals = {...context}.goals
		//                     goals[event.index].animating = true
		// 					return assign({ goals: goals });
		// 				}
		// 			},
		// 			STOP_ANIMATION: {
		// 				actions: (context, event) => {
		// 					const goals = {...context}.goals
		//                     goals[event.index].animating = false
		// 					return assign({ goals: goals });
		// 				}
		// 			}
		// 		}
		// 	}
		// }
	});
};

export default HeaderMachine;
